const menuTypes = {
  TOGGLE: 'menu/toggle',
  SHOW: 'menu/show',
  HIDE: 'menu/hide',
};

export default menuTypes;
